import { ReactNode, useEffect, useState } from 'react';

const ID = 'page-specific-style';

/**
 * ページごとにcssを適用するためのhooks。
 * Next.jsは、静的なcssを1つだけimportするか、module.cssを使うことしかできないが、
 * このhooksは、cssは静的なcssをpresentationファイルごとに読み込み、
 * かつ、クライアントサイドレンダリングにおいて、スタイルの適用が遅れないようにする。
 * @param css cssのファイル名（拡張子は不要）
 */
export const usePageSpecificCSS = (css?: string, index?: number): { CSSLinkTag: ReactNode; isLoadingCSS: boolean } => {
  if (css === undefined) return { CSSLinkTag: null, isLoadingCSS: false };

  const [isLoadingCSS, setIsLoadingCSS] = useState(true);
  const id = `${ID}-${index}`;

  // Reactの描画が完了するまで待つ
  useEffect(() => {
    // ブラウザがスタイルを読み込むまで待つ
    const css = document.getElementById(id) as HTMLLinkElement;
    const timer = setInterval(() => {
      if (css.sheet?.rules?.length) {
        setIsLoadingCSS(false);
        clearInterval(timer);
      }
    }, 30); // about 30fps
  }, []);

  return {
    CSSLinkTag: <link rel="stylesheet" href={`/style/${css}.css`} id={id} key={index} />,
    isLoadingCSS,
  };
};
